import {Cascader, CascaderProps} from "antd";
import {useEffect, useMemo, useState} from "react";

type CategoryCascaderProps = CascaderProps & {onChange?:(v:any)=> {  }, value?:any};

function CategoryCascader(props: CategoryCascaderProps) {
    const {value = "value", children = "children", label = "label"} = props.fieldNames ?? {};
    // const [allOptions, setAllOptions] = useState<any>([]);
    const [valueArray, setValueArray] = useState<Array<any>>([]);
    // useEffect(() => {
    //     setAllOptions(flatOptions(props.options||[]));
    // }, [props.options]);
    const allOptions = useMemo(() => {
        return flatOptions(props.options || [])
    }, [props.options]);
    useEffect(() => {
        if (!props.value) {
            setValueArray([]);
            return;
        }
        const opt = allOptions.find((o: any) => o[value] === props.value);
        const parents = opt?.parents || '';
        const values = parents.split('/').map((p: string) => parseInt(p)).filter((p: any) => !!p)
        setValueArray([...values, props.value]);
    }, [props.value, allOptions]);

    const onChange = (value: Array<any>, selectedOptions: Array<any>) => {

        const v = Array.isArray(value)?value[value.length - 1]:value;
        props.onChange?.(v);
    }

    // @ts-ignore
    function flatOptions(ops: Array<any>) {
        return ops.map(o => o.children ? [o, ...flatOptions(o.children as Array<any>)] : [o]).flat();
    }

    return <Cascader {...props} value={valueArray} onChange={onChange}/>
}

export default CategoryCascader;